import { createFileRoute, Link } from "@tanstack/react-router";
import { Helmet } from "react-helmet-async";

import { MarketingLayout } from "@/components/marketing/MarketingLayout";
import { Section } from "@/components/marketing/layout/Section";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { ExcelAddinInstructions } from "@/components/portal/shared/ExcelAddinInstructions";

export const Route = createFileRoute("/products/myapp_/excel-addin-setup")({
  component: MyAppExcelAddinSetupPage,
});

function MyAppExcelAddinSetupPage() {
  return (
    <MarketingLayout>
      <Helmet>
        <title>
          MyApp Excel Add-in - Setup guide for Microsoft 365 admins | Larasoft
        </title>
        <meta
          name="description"
          content="Step-by-step instructions for deploying the MyApp Excel Add-in via the Microsoft 365 admin centre. Share this page with your IT team."
        />
        <meta name="robots" content="noindex,follow" />
        <link
          rel="canonical"
          href="https://larasoft.global/products/myapp/excel-addin-setup"
        />
      </Helmet>

      <Section containerClassName="space-y-6" className="py-12">
        <div className="space-y-3">
          <Badge className="w-max" variant="info">
            MyApp Excel Add-in
          </Badge>
          <h1 className="text-3xl sm:text-4xl font-extrabold leading-tight">
            Setup guide for your Microsoft 365 admin
          </h1>
          <p className="max-w-3xl text-slate-600">
            This page is designed to be shared with the IT team or external
            provider that manages your Microsoft 365 environment. It contains
            everything they need to deploy the MyApp Excel Add-in to your
            users.
          </p>
        </div>
      </Section>

      <Section
        containerClassName="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm sm:p-8"
        className="pb-16"
      >
        <ExcelAddinInstructions />
      </Section>

      <Section
        containerClassName="text-center space-y-4"
        className="pb-20"
      >
        <p className="text-sm text-slate-600">
          Looking for the product overview?
        </p>
        <Button asChild variant="outline">
          <Link to="/products/myapp">Back to MyApp</Link>
        </Button>
      </Section>
    </MarketingLayout>
  );
}
